import Services from '../../services';

import { message } from 'antd'; // @todo not service's concern

export default class Service extends Services {

  listCompany = async (tokenValue) => {
    const tokenLogin = localStorage.getItem('token');
    try {
      const response = await fetch(`${this.endPoint}Empresa`, {
        method: 'GET',
        headers: {
          Authorization: `Bearer ${tokenLogin}`,
          'Content-Type': 'text/plain',
        },
      });

      const json = await response.json();

      return json;
    } catch (err) {
      console.log('Error problem', err);
      this.doLogout()
    }
  };

  listCompanyFilial = async (tokenValue) => {
    const tokenLogin = localStorage.getItem('token');
    try {
      const response = await fetch(`${this.endPoint}Filial`, {
        method: 'GET',
        headers: {
          Authorization: `Bearer ${tokenLogin}`,
          'Content-Type': 'text/plain',
        },
      });

      const json = await response.json();

      return json;
    } catch (err) {
      console.log('Error problem', err);
      this.doLogout()
    }
  };

  listSegment = async () => {
    const tokenLogin = localStorage.getItem('token');
    try {
      const response = await fetch(`${this.endPoint}Segmento`, {
        method: 'GET',
        headers: {
          Authorization: `Bearer ${tokenLogin}`,
          'Content-Type': 'text/plain',
        },
      });

      const json = await response.json();

      return json;
    } catch (err) {
      console.log('Error problem', err);
      this.doLogout()
    }
  };

  listUserCompany = async (tokenValue) => {
    const tokenLogin = localStorage.getItem('token');
    try {
      const response = await fetch(`${this.endPoint}Empresa/getUsuariosEmpresaFilial`, {
        method: 'GET',
        headers: {
          Authorization: `Bearer ${tokenLogin}`,
          'Content-Type': 'text/plain',
        },
      });

      const json = await response.json();

      return json;
    } catch (err) {
      console.log('Error problem', err);
      this.doLogout()
    }
  };


  deleteUser = async (body) => {
    console.log("body", body)
    const tokenLogin = localStorage.getItem('token');
    try {
      const response = await fetch(`${this.endPoint}Empresa/excluirUsuarioEmpresa`, {
        method: 'PUT',
        headers: {
          Authorization: `Bearer ${tokenLogin}`,
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(body),
      });

      const json = await response.json();
      console.log("json", json)

      return json;
    } catch (err) {
      console.log('Error problem', err);
      this.doLogout()
    }
  };

  promoverAcessoTotal = async (body) => {
    const tokenLogin = localStorage.getItem('token');
    try {
      const response = await fetch(`${this.endPoint}Empresa/promoverAcessoTotal`, {
        method: 'PUT',
        headers: {
          Authorization: `Bearer ${tokenLogin}`,
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(body),
      });

      // Diferente dos endpoints mais novos (que usam Forbid()/403),
      // ExcluirVinculoUsuario/PromoverAcessoTotal seguem o padrao mais antigo
      // do projeto: sempre devolvem HTTP 200, com sucesso/falha so no corpo
      // (ReturnObjectDto.code). So quem ja tem acesso total pode promover
      // outra pessoa (2026-08-10) - o backend bloqueia de verdade; aqui so
      // repassamos o resultado pra quem chamou decidir o que mostrar.
      const json = await response.json();

      return json;
    } catch (err) {
      console.log('Error problem', err);
    }
  };

  adicionarUnidades = async (body) => {
    const tokenLogin = localStorage.getItem('token');
    try {
      const response = await fetch(`${this.endPoint}Empresa/adicionar-unidades`, {
        method: 'PUT',
        headers: {
          Authorization: `Bearer ${tokenLogin}`,
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(body),
      });

      const json = await response.json();

      return json;
    } catch (err) {
      console.log('Error problem', err);
    }
  };

  createCompanyFilial = async (body) => {
    const tokenLogin = localStorage.getItem('token');
    try {
      const response = await fetch(`${this.endPoint}Filial`, {
        method: 'POST',
        headers: {
          Authorization: `Bearer ${tokenLogin}`,
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(body),
      });

      // Forbid() do backend devolve 403 com corpo vazio - response.json() estoura
      // SyntaxError nesse caso e cai no catch, que deslogava o usuario (mesmo
      // sintoma documentado no TODO.txt pra qualquer erro de fetch). Usuario
      // restrito por unidade (2026-08-09) toma 403 de proposito ao tentar criar
      // filial - trata como erro de permissao, nao sessao invalida.
      if (response.status === 403) {
        message.error('Você não tem permissão para criar uma unidade nesta empresa.');
        return null;
      }

      const json = await response.json();

      return json;
    } catch (err) {
      console.log('Error problem', err);
      this.doLogout()
    }
  };

  // Create Ivitation
  createInvitation = async (body) => {
    const tokenLogin = localStorage.getItem('token');
    try {
      const response = await fetch(`${this.endPoint}Convite`, {
        method: 'POST',
        headers: {
          Authorization: `Bearer ${tokenLogin}`,
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(body),
      });

      // Ver comentario em createCompanyFilial - so quem tem acesso total pode
      // convidar (checagem de posse adicionada no back, 2026-08-12); sem isso,
      // o corpo vazio do Forbid() estourava SyntaxError em response.json() e
      // caia no catch abaixo, que deslogava o usuario.
      if (response.status === 403) {
        message.error('Você não tem permissão para convidar usuários para essa empresa.');
        return null;
      }

      const json = await response.json();

      return json;
    } catch (err) {
      console.log('Error problem', err);
      this.doLogout()
    }
  };

  cancelInvitation = async (body) => {
    const tokenLogin = localStorage.getItem('token');
    try {
      const response = await fetch(`${this.endPoint}Convite`, {
        method: 'DELETE',
        headers: {
          Authorization: `Bearer ${tokenLogin}`,
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(body),
      });

      if (response.status === 403) {
        message.error('Você não tem permissão para cancelar esse convite.');
        return null;
      }

      const json = await response.json();

      return json;
    } catch (err) {
      console.log('Error problem', err);
    }
  };

  getListQuestions = async () => {
    const tokenLogin = localStorage.getItem('token');
    try {
      const response = await fetch(`${this.endPoint}Questionario/GetPerguntasAtivas`, {
        method: 'GET',
        headers: {
          Authorization: `Bearer ${tokenLogin}`,
          'Content-Type': 'text/plain',
        },
      });

      const json = await response.json();

      return json;
    } catch (err) {
      let error =
        err.mensage != undefined && err.mensage ?
          err.mensage : 'Houve um erro ao resgatar os quesitos.';
      message.error(error);
    }
  };

  createListQuestions = async (body) => {
    const tokenLogin = localStorage.getItem('token');
    try {
      const response = await fetch(`${this.endPoint}Questionario/VincularPerguntaAEmpresa`, {
        method: 'POST',
        headers: {
          Authorization: `Bearer ${tokenLogin}`,
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(body),
      });

      // Ver comentario em createCompanyFilial - mesmo cuidado com 403 (usuario
      // restrito por unidade nao pode alterar quesitos, 2026-08-09).
      if (response.status === 403) {
        message.error('Você não tem permissão para alterar os quesitos desta empresa.');
        return null;
      }

      const json = await response.json();

      return json;
    } catch (err) {
      console.log('Error problem', err);
      this.doLogout()
    }
  };

  getAlertStatus = async (tokenValue) => {
    const tokenLogin = localStorage.getItem('token');
    try {
      const response = await fetch(`${this.endPoint}Alerta`, {
        method: 'GET',
        headers: {
          Authorization: `Bearer ${tokenLogin}`,
          'Content-Type': 'text/plain',
        },
      });

      const json = await response.json();

      return json;
    } catch (err) {
      console.log('Error problem', err);
      this.doLogout()
    }
  };

  setAlertStatus = async (body) => {
    console.log('body', body);
    const tokenLogin = localStorage.getItem('token');
    try {
      const response = await fetch(`${this.endPoint}Alerta`, {
        method: 'PUT',
        headers: {
          Authorization: `Bearer ${tokenLogin}`,
          'Content-Type': 'text/plain',
        },
        body: JSON.stringify(body),
      });

      const json = await response.json();

      return json;
    } catch (err) {
      console.log('Error problem', err);
      this.doLogout()
    }
  };

  updateCompany = async (body) => {
    const tokenLogin = localStorage.getItem('token');
    try {
      const response = await fetch(`${this.endPoint}Empresa/alterarEmpresa`, {
        method: 'PUT',
        headers: {
          Authorization: `Bearer ${tokenLogin}`,
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(body),
      });

      // Ver comentario em createCompanyFilial - mesmo cuidado com 403 (usuario
      // restrito por unidade nao pode editar dados da empresa, 2026-08-09).
      if (response.status === 403) {
        message.error('Você não tem permissão para editar os dados desta empresa.');
        return null;
      }

      const json = await response.json();

      return json;
    } catch (err) {
      console.log('Error problem', err);
      this.doLogout()
    }
  };

  updateFilial = async (body) => {
    const tokenLogin = localStorage.getItem('token');
    try {
      const response = await fetch(`${this.endPoint}Filial`, {
        method: 'PUT',
        headers: {
          Authorization: `Bearer ${tokenLogin}`,
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(body),
      });

      const json = await response.json();

      return json;
    } catch (err) {
      console.log('Error problem', err);
      this.doLogout()
    }
  };

  saveBeneficio = async (body) => {
    const tokenLogin = localStorage.getItem('token');
    try {
      const response = await fetch(`${this.endPoint}Beneficio`, {
        method: 'POST',
        headers: {
          Authorization: `Bearer ${tokenLogin}`,
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(body),
      });

      // Nao desloga hoje (sem this.doLogout() aqui), mas response.json() sobre
      // corpo vazio do 403 falharia silenciosamente sem avisar o usuario -
      // usuario restrito por unidade nao pode configurar cupom (2026-08-09).
      if (response.status === 403) {
        message.error('Você não tem permissão para configurar o cupom desta empresa.');
        return null;
      }

      const json = await response.json();

      return json;
    } catch (err) {
      console.log('Error problem', err);
    }
  };

  pesquisarCupom = async (idFilial, numero) => {
    const tokenLogin = localStorage.getItem('token');
    try {
      const response = await fetch(`${this.endPoint}Beneficio/PesquisarCupom/${idFilial}/${numero}`, {
        method: 'GET',
        headers: {
          Authorization: `Bearer ${tokenLogin}`,
          'Content-Type': 'application/json',
        }
      });

      if (response.status === 403) {
        message.error('Você não tem permissão para pesquisar cupom nesta unidade.');
        return null;
      }

      const json = await response.json();

      return json;
    } catch (err) {
      console.log('Error problem', err);
    }
  }

  utilizarCupom = async (idFilial, numero) => {
    const tokenLogin = localStorage.getItem('token');
    try {
      const response = await fetch(`${this.endPoint}Beneficio/UtilizarCupom/${idFilial}/${numero}`, {
        method: 'POST',
        headers: {
          Authorization: `Bearer ${tokenLogin}`,
          'Content-Type': 'application/json',
        }
      });

      if (response.status === 403) {
        message.error('Você não tem permissão para utilizar cupom nesta unidade.');
        return null;
      }

      const json = await response.json();

      return json;
    } catch (err) {
      console.log('Error problem', err);
    }
  }

  getListQuestionsEmpresa = async (idEmpresa) => {
    const tokenLogin = localStorage.getItem('token');
    try {
      const response = await fetch(`${this.endPoint}Questionario/GetPerguntasEmpresa?idEmpresa=${idEmpresa}`, {
        method: 'GET',
        headers: {
          Authorization: `Bearer ${tokenLogin}`,
          'Content-Type': 'text/plain',
        },
      });

      const json = await response.json();

      return json;
    } catch (err) {
      let error =
        err.mensage != undefined && err.mensage ?
          err.mensage : 'Houve um erro ao resgatar os quesitos.';
      message.error(error);
    }
  };

  
}
